import axios from "axios";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const LoadingComponent = () => (
  <Container style={{ textAlign: "center" }}>
    <Row>
      <Col xs={12} >
        <h1 className="loading">Loading...</h1>
        <br />
      </Col>
    </Row>
    {/* <LinearProgress /> */}
  </Container>
);

const ErrorComponent = () => (
  <Container style={{ textAlign: "center" }}>
    <Row>
      <Col xs={12} >
        <h1></h1>
      </Col>
    </Row>
  </Container>
);

const HTTPRequest = (props) =>  {
  // stage 0 = loading, 1 = success, 2 = error
  const [requestStage, setRequestStage] = useState(0);
  const [data, setData] = useState(null);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState(null);
  
  
  useEffect(() => {
    httpCall(props.url, props.requestObject);
  },[])
  
  const httpCall = async (url, requestObject) => {
    try {
      const result = await axios.post(url, requestObject);
      // const requestStage = 1;
      const { data, status } = await result;
      //
      const { customErrorCondition } = props;
      if (customErrorCondition(data)) {
        throw new Error("customError");
      } else {
        const newData = 
        data.map(item => {
          return {...item, additionalUsers: 0}
        });
        setData(newData);
        props.setPackages(newData);
        setStatus(status);
        setRequestStage(1);
        return await { newData, status, requestStage };
      }
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        const status = error.response.status;
        const message = error.response.message;
        const requestStage = 2;
        setMessage(message);
        setStatus(status);
        setRequestStage(requestStage);
        return { status, message, requestStage };
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // console.log(error.request);
        // console.log(error.request.status);
        const { status } = error.request;
        const message = "Please check your connection and try again";
        const requestStage = 2;
        console.log(message);
        setMessage(message);
        setStatus(status);
        setRequestStage(requestStage);
        return await { status, message, requestStage };
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
        const requestStage = 2;
        const message = error.message;
        setMessage(message);
        setRequestStage(requestStage);
        return await { message, requestStage };
      }
    }
  };

    return (
      <Fragment>
        {requestStage === 1 && props.children(data)}
        {requestStage === 2 && props.errorComponent()}
        {requestStage === 0 && props.loadingComponent()}
      </Fragment>
    );
  }


HTTPRequest.defaultProps = {
  errorComponent: ErrorComponent,
  loadingComponent: LoadingComponent,
  customErrorCondition: () => false
};

HTTPRequest.propTypes = {
  url: PropTypes.string.isRequired,
  requestObject: PropTypes.object,
  loadingComponent: PropTypes.func,
  children: PropTypes.func.isRequired,
  errorComponent: PropTypes.func,
  customErrorCondition: PropTypes.func
};
export default HTTPRequest;
